import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ReviewState } from '../reducers/types';

const reviewSlice = createSlice({
  name: 'review',
  initialState: { approved: {}, activePage: {} } as ReviewState,
  reducers: {
    setActivePage(
      state,
      action: PayloadAction<{ prNumber: number; index: number }>,
    ) {
      state.activePage[String(action.payload.prNumber)] = action.payload.index;
    },
    toggleApprovedPage(
      state,
      action: PayloadAction<{ prNumber: number; pageIndex: number }>,
    ) {
      const key = String(action.payload.prNumber);
      const current = state.approved[key] ?? [];
      const set = new Set(current);
      if (set.has(action.payload.pageIndex)) {
        set.delete(action.payload.pageIndex);
      } else {
        set.add(action.payload.pageIndex);
      }
      state.approved[key] = [...set];
    },
  },
});

export const { setActivePage, toggleApprovedPage } = reviewSlice.actions;
export default reviewSlice.reducer;
